const __WEBPACK_NAMESPACE_OBJECT__ = require("@linusborg/vue-simple-portal");